var $ = require('jquery');

module.exports = {
	init: function () {
		// console.log(
		// 	'Menu module initialized',
		// 	$('#mobile-menu-toggle'),
		// 	$('.header__desktop-nav'),
		// 	$('#mobile-menu-close'),
		// 	$('.nav-toggle')
		// );
		var menuBreakpoint = 1024;
		// New mobile menu toggle
		$('#mobile-menu-toggle').on('click', function () {
			$('.header__desktop-nav').toggleClass('--hidden');
			$('.header__desktop-nav').toggleClass('--visible');
			$('.header__featured-nav').toggleClass('--hidden');
			$('.header__featured-nav').toggleClass('--visible');
			$('#main-menu').toggleClass('header--overlay');

			if ($(this).attr('aria-expanded') === 'true') {
				$(this).attr('aria-expanded', 'false');
			} else {
				$(this).attr('aria-expanded', 'true');
			}
			// Set max height of main menu to viewport height minus other header elements
			var viewportHeight = $(window).height();
			var wpadminbarHeight = $('#wpadminbar').outerHeight() || 0;
			var headerTopHeight = $('.header__top').outerHeight() || 0;
			var headerLogoHeight = $('.header__logo').outerHeight() || 0;
			var featuredNavHeight = $('.header__featured-nav').outerHeight() || 0;
			var maxMenuHeight =
				viewportHeight -
				wpadminbarHeight -
				headerTopHeight -
				headerLogoHeight -
				featuredNavHeight +
				5;
			//console.log(viewportHeight, wpadminbarHeight, headerTopHeight, maxMenuHeight);
			$('.header__desktop-nav').css('max-height', maxMenuHeight + 'px');
		});

		// Toggle dropdown on button click
		$('.header__dropdown-toggle').on('click', function () {
			var $button = $(this);
			var $dropdownItem = $button.closest('.header__dropdown-item');
			var $dropdownMenu = $dropdownItem.find('.header__dropdown-menu');

			var isExpanded = $button.attr('aria-expanded') === 'true';

			if (isExpanded) {
				// Close this dropdown
				$button.attr('aria-expanded', false);
				$dropdownItem.removeClass('--dropdown-open');
				$dropdownMenu.hide();
			} else {
				// Close all other dropdowns first
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();

				// Open this dropdown
				$button.attr('aria-expanded', true);
				$dropdownItem.addClass('--dropdown-open');
				$dropdownMenu.show();
			}
		});

		// Allow tab navigation for dropdown menu
		// $('.header__dropdown-link').on('focus', function () {
		// 	var $item = $(this).closest('.header__dropdown-item');
		// 	$item.find('.header__dropdown-toggle').attr('aria-expanded', true);
		// 	$item.addClass('--dropdown-open');
		// 	$item.find('.header__dropdown-menu').show();
		// });

		$('.header__dropdown-item').on('focusout', function () {
			var $this = $(this);
			setTimeout(function () {
				if (!$this.find(':focus').length) {
					$this.find('.header__dropdown-toggle').attr('aria-expanded', false);
					$this.removeClass('--dropdown-open');
					$this.find('.header__dropdown-menu').hide();
				}
			}, 100);
		});

		// Close dropdowns when clicking outside
		$(document).on('click', function (event) {
			if (!$(event.target).closest('.header__dropdown-item').length) {
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();
			}
		});

		// Close dropdowns on escape key
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape' || event.keyCode === 27) {
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();
			}
		});

		// Hover functionality for dropdown menus
		$('.header__dropdown-item').on('mouseenter', function () {
			//console.log('mouse entered');
			if ($(window).width() <= menuBreakpoint) {
				return; // Skip hover functionality on mobile
			}
			var $item = $(this);
			var $button = $item.find('.header__dropdown-toggle');
			var $menu = $item.find('.header__dropdown-menu');

			// Close all other dropdowns first
			$('.header__dropdown-item').not($item).removeClass('--dropdown-open');
			$('.header__dropdown-toggle').not($button).attr('aria-expanded', false);
			$('.header__dropdown-menu').not($menu).hide();

			// Open this dropdown
			$button.attr('aria-expanded', true);
			$item.addClass('--dropdown-open');
			$menu.show();
		});

		$('.header__dropdown-item').on('mouseleave', function () {
			//console.log('mouse left');
			if ($(window).width() <= menuBreakpoint) {
				return; // Skip hover functionality on mobile
			}
			var $item = $(this);
			var $button = $item.find('.header__dropdown-toggle');
			var $menu = $item.find('.header__dropdown-menu');

			// Close this dropdown
			$button.attr('aria-expanded', false);
			$item.removeClass('--dropdown-open');
			$menu.hide();
		});

		// Handle focus trap within mobile menu when open
		var focusableElements = $('#main-menu').find('a, input, select, textarea, button'); // Adjust selector as needed
		var lastElement = focusableElements.last();
		var firstElement = focusableElements.first();

		lastElement.on('focusout', function () {
			// Use a small timeout to ensure the browser has processed the focusout
			// before attempting to set focus again, preventing potential race conditions.
			setTimeout(function () {
				if ($(window).width() > menuBreakpoint) {
					return; // Skip focus trap on desktop
				}
				// Check if focus is still outside the desired elements
				// (e.g., if the user clicked elsewhere on the page)
				if (!focusableElements.is(':focus')) {
					firstElement.focus();
				}
			}, 10);
		});

		function resizeHandler() {
			if (window.innerWidth > menuBreakpoint) {
				// Close all dropdowns
				$('.header__dropdown-item').removeClass('--dropdown-open');
				$('.header__dropdown-toggle').attr('aria-expanded', false);
				$('.header__dropdown-menu').hide();
				$('.header__desktop-nav').removeClass('--hidden');
				$('.header__featured-nav').removeClass('--hidden');
			}
		}

		$(window).on('resize', function () {
			resizeHandler();
		});

		$(window).on('load', function () {
			// Add --hiden class to desktop nav by default on load
			if (window.innerWidth <= menuBreakpoint) {
				$('.header__desktop-nav').addClass('--hidden');
				$('.header__featured-nav').addClass('--hidden');
			}
			resizeHandler();
		});
	},
};
